/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { createContext, type ReactNode, useContext } from "react";
import type { SiteTheme } from "../interfaces";

const SiteThemeContext = createContext<SiteTheme>("brand1");

interface Props {
  children: ReactNode;
  value: SiteTheme | undefined;
}

export const SiteThemeProvider = ({ children, value }: Props) => {
  return <SiteThemeContext value={value ?? "brand1"}>{children}</SiteThemeContext>;
};

export const useSiteTheme = (): SiteTheme => {
  const context = useContext(SiteThemeContext);
  return context ?? "brand1";
};
